<template>
  <div>
    <form class="form__form" id="main-form" method="post">
      <input
        class="form__form-input"
        @keydown="enterClick"
        v-model="input"
        @change="change"
        @input="onInput"
        type="text"
        name="url"
        :placeholder="inputPlaceholder"
        autofocus="true"
        required
        id="id_url"
      >
      <button
        class="form__form-button"
        type="submit"
        id="search"
        @click.prevent="submit"
      >
        <span>{{ startButton }}</span>
      </button>
    </form>
    <p class="form__note">
      {{ note }}
      <a
        class="form__note-link"
        :href="noteLink"
      >Terms of Use</a>.
    </p>
  </div>
</template>

<script>
import validUrl from '../tools/validUrl';
import { envProps } from '@js-packages/experiment-loader';

export default {
  props: ['inputPlaceholder', 'startButton', 'note', 'noteLink'],
  data() {
    return {
      input: null,
      hls: false,
      processing: false,
      initialInput: null,
      isInstagram: false,
    }
  },
  mounted() {
    this.isInstagram =
      window?.location.pathname?.includes('instagram') ||
      window?.location?.href.includes('instagram');

    if (localStorage.getItem("search")) {
      this.input = localStorage.getItem("search");
      localStorage.removeItem("search");
      setTimeout(() => {
        this.change();
        this.submit();
      }, 100);
    }

    this.$root.$on('link-cast', (link) => {
      this.input = link;
      this.submit();
    });

    this.$root.$on('result-end', () => {
      this.processing = false;
    });

    const device = envProps.device;

    if (device.type === 'mobile' && window.innerHeight > 400) {
      const input = document.getElementById("id_url");
      input.blur();
      input.addEventListener("focus", () => {
        const iframe = document.querySelector("html > iframe");
        if (iframe) {
          iframe.style.display = "none";
        }
      })
      input.addEventListener("click", () => {
        const iframe = document.querySelector("html > iframe");
        if (iframe) {
          iframe.style.display = "none";
        }

      })
      input.addEventListener("blur", () => {
        const iframe = document.querySelector("html > iframe");
        if (iframe) {
          iframe.style.display = "block";
        }
      })
    }

    const pathname = document.location.pathname;
  },
  methods: {
    enterClick(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.submit();
      }
    },
    submit() {
      if (this.hls) {
        return;
      }
      if (typeof this.input !== 'string' || this.input.trim() === '') {
        return
      }
      this.$root.$emit('clear-results');
      if (validUrl(this.input)) {
        if (this.processing) {
          return;
        }
        this.processing = true;
        this.$root.$emit('new-request')
        this.$root.$emit('search-request', null);
        if (this.checkForStories(this.input)) {
          this.$root.$emit('straight-submit', this.input)
        } else {
          if(this.isInstagram && !this.checkForPosts(this.input) ){
            this.$root.$emit('search-request', this.input);
          }else{
            this.$root.$emit('link-submit', this.input);
          }
        }
      } else {
        this.$root.$emit('search-request', this.input);
      }
    },
    change() {
      if (validUrl(this.input)) {
        this.$root.$emit('link-insert', this.input);
      } else {
        this.$root.$emit('keyword-insert', this.input);
      }
    },
    onInput(event) {
      if (
        event.inputType === 'insertFromPaste' ||
        event.inputType === 'insertFromDrop' ||
        event.inputType === 'insertFromYank'
      ) {
        if (validUrl(this.input)) {
          this.submit();
        }
      }
    },
    checkForStories(link) {
      const stories = link.match(/(?:instagram\.com|instagr\.am)\/stories\/([A-Za-z0-9-_\.]+)\/([A-Za-z0-9-_\.]+)/im)
      const highlights = link.match(/(?:instagram\.com|instagr\.am)\/stories\/highlights\/([A-Za-z0-9-_\.]+)/im)
      if (stories || highlights) {
        return true
      }
    },
    checkForPosts(input) {
      const posts = input.match(/^(https:\/\/|http:\/\/)?(www\.)?(instagram\.(com|org)|instagr\.am)(\/(p|tv|reel|reels))/gims)
      if (posts) {
        return true
      }
    }
  }
}
</script>

